import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import { type EmailTemplateOwner } from '@/models/emailTemplate'

interface TeammateSelectProps {
  owners: EmailTemplateOwner[]
  value: string
  onValueChange: (ownerId: string) => void
}

export function TeammateSelect({ owners, value, onValueChange }: TeammateSelectProps) {
  return (
    <Select value={value} onValueChange={onValueChange}>
      <SelectTrigger className="w-full" aria-label="Teammate">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {owners.map((owner) => (
          <SelectItem key={owner.id} value={owner.id}>
            {owner.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
